var exports = {
  "t8": "MobileFriendRequestItem.module__requestItem___RmhTdX",
  "eF": "MobileFriendRequestItem.module__userInfo___RmhTdX",
  "nT": "MobileFriendRequestItem.module__userName___RmhTdX",
  "G2": "MobileFriendRequestItem.module__requestStatus___RmhTdX",
  "hP": "MobileFriendRequestItem.module__actionButton___RmhTdX" + " " + __webpack_require__(77126)["AS"] + " " + __webpack_require__(77126)["ik"],
  "RK": "MobileFriendRequestItem.module__iconSize___RmhTdX",
};

module.exports = exports;
